import { createAsyncThunk } from '@reduxjs/toolkit'
import { Api, paths } from 'shared/services'
import { MODULE_NAME } from '../strings'
import { SubmitFeedbackPayload } from './action.types'

export const deleteAccount = createAsyncThunk<
  void,
  undefined,
  { rejectValue: string }
>(`${MODULE_NAME}/deleteAccount`, async (data, thunkAPI) => {
  try {
    const response = await Api.delete(paths.Users.root)
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue(error)
  }
})

export const submitFeedback = createAsyncThunk<
  void,
  SubmitFeedbackPayload,
  { rejectValue: string }
>(`${MODULE_NAME}/submitFeedback`, async (data, thunkAPI) => {
  try {
    const response = await Api.post(paths.Users.feedbacks, data)
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue(error)
  }
})
